import React from 'react';
import { motion } from 'framer-motion';
import {
  BadgeCheck,
  LineChart,
  ShieldCheck,
  Sparkles,
  Zap,
} from 'lucide-react';
import {
  homeScrollItem,
  homeScrollStagger,
  homeScrollViewport,
} from '../../utils/homeScrollMotion';
import styles from './ServiceAdvantagesSection.module.css';

const BENEFIT_ICONS = [ShieldCheck, Zap, BadgeCheck, LineChart];

const ServiceAdvantagesSection = ({ hue = 'green', benefits = [] }) => {
  if (!benefits.length) return null;

  return (
    <section className={styles.section} data-hue={hue} aria-labelledby="benefits-heading">
      <div className={styles.bg} aria-hidden="true">
        <span className={styles.washGreen} />
        <span className={styles.washOrange} />
      </div>

      <div className={styles.inner}>
        <motion.header
          className={styles.header}
          variants={homeScrollItem}
          initial="hidden"
          whileInView="visible"
          viewport={homeScrollViewport}
        >
          <span className={styles.eyebrow}>
            <Sparkles size={13} strokeWidth={2.4} aria-hidden="true" />
            Why buyers choose us
          </span>
          <h2 id="benefits-heading" className={styles.title}>
            Key <span className={styles.titleAccent}>advantages</span>
          </h2>
          <p className={styles.subtitle}>
            Tangible outcomes for your line — not generic promises
          </p>
        </motion.header>

        <motion.ul
          className={styles.grid}
          variants={homeScrollStagger}
          initial="hidden"
          whileInView="visible"
          viewport={homeScrollViewport}
        >
          {benefits.map((benefit, index) => {
            const Icon = BENEFIT_ICONS[index % BENEFIT_ICONS.length];

            return (
              <motion.li
                key={benefit.title}
                className={styles.card}
                data-tone={index % 2 === 0 ? 'green' : 'coral'}
                variants={homeScrollItem}
              >
                <span className={styles.cardGlow} aria-hidden="true" />
                <span className={styles.iconWrap} aria-hidden="true">
                  <Icon size={22} strokeWidth={2.2} />
                </span>
                <h3 className={styles.cardTitle}>{benefit.title}</h3>
                <p className={styles.cardText}>{benefit.description}</p>
                <span className={styles.cardFoot} aria-hidden="true" />
              </motion.li>
            );
          })}
        </motion.ul>
      </div>
    </section>
  );
};

export default ServiceAdvantagesSection;
